import { render, staticRenderFns } from "./RecordingDetails.vue?vue&type=template&id=117b5d5c"
import script from "./RecordingDetails.vue?vue&type=script&lang=js"
export * from "./RecordingDetails.vue?vue&type=script&lang=js"
import style0 from "./RecordingDetails.vue?vue&type=style&index=0&id=117b5d5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports